export type Eleccion = '2023_c' | '2022_s' | '2021_d' | '2021_c'

const elecciones: { [key in Eleccion]: { label: string; order: number } } = {
  '2021_c': {
    label: '2021 CONSTITUYENTES',
    order: 4,
  },
  '2021_d': {
    label: '2021 DIPUTADAS/OS',
    order: 3,
  },
  '2022_s': {
    label: '2022 PLEBISCITO SALIDA',
    order: 2,
  },
  '2023_c': {
    label: '2023 C. CONSTITUCIONAL',
    order: 1,
  },
}

export default elecciones
